import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-md mb-4" }
const _hoisted_2 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_commissions_summary = _resolveComponent("commissions-summary")!
  const _component_commissions_detail = _resolveComponent("commissions-detail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_commissions_summary, { summary: _ctx.summary }, null, 8, ["summary"])
    ]),
    _createVNode(_component_commissions_detail, {
      loading: _ctx.loading,
      commissions: _ctx.commissions
    }, null, 8, ["loading", "commissions"])
  ]))
}